import snakeCase from 'lodash/snakeCase'
import moment from 'shared/lib/moment'

const humanizedDateFormat = (t, format) => {
  // By passing an array to t, it will fallback to format if the translation is not found
  // Our parseMissingKeyHandler handles displaying the fallback
  return t([`common.date_time_input_placeholders.${snakeCase(format)}`, format])
}

/**
 * Parses an ISO datetime string into separate date and time components
 * @param {string} isoString - ISO datetime string
 * @returns {{date: string, time: string}} Object with date (ISO string) and time (HH:mm string) properties
 */
export const parseDateTime = (isoString) => {
  if (!isoString) return { date: '', time: '00:00' }

  const moment_obj = moment(isoString)
  return {
    date: moment_obj.toISOString(),
    time: moment_obj.format('HH:mm')
  }
}

export default humanizedDateFormat
